import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';

@Component({
  selector: 'dialog-info',
  template: `<div class="modal__content">
  <div class="modal__header" *ngIf="title">
    <h3>
      <span class="icon-info"></span>
      <span>{{title}}</span>
    </h3>
  </div>
  <div class="modal__body" *ngIf="message">
    <p>{{message}}</p>
  </div>
  <div class="modal__footer text-center">
    <button cuiButton color="primary" (click)="done()">{{buttonText}}</button>
  </div>
</div>`,
  styles: [``]
})
export class InfoDialogComponent {
  private _title: string;
  public get title(): string { return this._title; }

  private _message: string;
  public get message(): string { return this._message; }

  private _buttonText: string;
  public get buttonText(): string { return this._buttonText; }

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._title = data.title || null;
    this._message = data.message || null;
    this._buttonText = data.buttonText || 'Ok';
  }

  public done(): void {
    this.dialogRef.close('done');
  }

}
